<template>
  <PageSecondary class="burnout">
    <template #title>Карбонара на сливках</template>
    <h4>Продукты на две порции</h4>
    
    
    <h5>Посуда</h5>
    <span> 
    - 3х литровая кастрюля - глубокая сковорода с крышкой - 2 глубокие тарелки -
    </span>
    
    
    <h5>Ингредиенты</h5>
    <span>
      - Спагетти La Molisana Quadrato #1 166гр (треть пачки 500гр)<br>
      - Бекон сырокопченый свежий 150гр<br>
      - Сливки 30% 190гр (есть во вкусвил)<br>
      - Чёрный перец из мельницы<br>
      - Пармезан или Пекорино 50гр<br>
    </span>
    
    
    <h5>Калорийность порции</h5>
    <span>
      895 ккал 26 бел. 20 жир. 59 угл.<br>
      <div style="font-size: smaller;">
      - Спагетти 290 ккал 11б 58у<br>
      - Бекон 225 ккал 8б 6ж<br>
      - Сливки 290 ккал 7ж 1у<br>
      - Сыр 90 ккал 7б 6ж<br>
      </div>
    </span>
    
    
    <!--<Ingredients
    :shit="'transmit'"
    :ingredients="ingredients"/>-->


    <h5>Готовим</h5>
    <span>
1. Налить 1,5 литра чистой холодной воды в кастрюлю и поставить на большой огонь до кипения. Положить треть чайной ложки соли.<br><br>
2. Острым ножом нарезать полоски бекона на квадратики.<br><br>
3. Поставить глубокую сковороду на средний огонь без масла.<br><br>
4. Не ломая положить спагетти в кипящую воду и дать тонуть. Варить 10 минут.<br><br>
5. Разложить квадратики бекона по поверхности сковороды. Когда все дно уложено засыпать верх остальными.<br><br>
6. Задача подрумянить треть бекона до состояния золотистой корочки, остальной бекон оставить нежным. Для этого перемешаем бекон, когда заметим что нижний подрумянился.<br><br>
7. Когда бекон поджарен, слить со сковороды весь жир.<br><br>
8. Вернуть сковороду на слабый огонь и залить бекон сливками, перемешать и дать согреться под крышкой, может кипеть.<br><br>
9. Проверить макароны на вкус, серединка должна быть чуть жесткая. Переложить макароны в сливки щипцами или вилкой.<br><br>
10. Всё перемешать и под крышкой дать пропитаться 3 минуты на малом огне.<br><br>
11. Проверить, что макароны доварились в сливках и разложить на глубокие подогретые тарелки.<br><br>
12. Помолоть черный перец поверх макарон.<br><br>
13. Посыпать мелко натёртый пармезан.<br><br>
14. Готово!<br><br>
<span>
  </PageSecondary>
</template>


<script>
import PageSecondary from "@/components/PageSecondary";
import Definition from "@/components/blocks/Definition";
import Ingredients from "@/components/components/Ingredients";

export default {
  name: "Carbonara",
  components: {PageSecondary, Definition, Ingredients},
  data() {
    return {
      ingredients: [
      'Спагетти La Molisana Quadrato #1 треть пачки 500гр (166гр)',
      'Бекон сырокопченый свежий 150гр',
      'Сливки 30% 190гр из вкусвил',
      'Чёрный перец из мельницы',
      'Пармезан или Пекорино 100гр']
    }
  }
};
</script>



<style lang="scss" scoped>
.burnout {
  span {
    display: block;
    margin-top: 24px;
  }

  img {
    width: 100%;
    margin-top: 24px;
  }

  h4 {
    margin-top: 40px;
  }
}
</style>
